import {useUnifyAdminStore} from '../../AdminStore';
import * as StyledComponents from '../StyledComponents';
import {CampaignNameInputWithHelperText} from '../Blocks/CampaignNameInputWithHelperText'
import get from 'lodash/get';
import { t } from 'i18next';

export const CampaignNameField = (): JSX.Element => {

    /**
     * Data Store
     */
    const campaignItems = useUnifyAdminStore((state) => state.campaignItems);
    const archiveSwitch = useUnifyAdminStore((state) => state.campaignArchiveSwitch);
    const updateCreateCampaignData = useUnifyAdminStore(
        (state) => state.updateCreateCampaignData
    );
    const permissions = useUnifyAdminStore(state => state.permissions);

    const name = get(campaignItems, 'name');
    const handleUpdateNameField = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        return updateCreateCampaignData({
            fieldName: 'name',
            value: {enUS: event.target.value, enCA: name?.enCA, frCA: name?.frCA},
        });
    };

    return (
        <StyledComponents.StyledCreateCampaignElementWrapper>
            <CampaignNameInputWithHelperText
                dataTestId="campaign-name-input"
                errorMessage="Please enter Name"
                id="campaign-name-abbr-input"
                inputDivider="left"
                label={t('campaigns.campaignName')}
                name="name"
                onChange={handleUpdateNameField}
                placeholder={t('campaigns.campaignNamePlaceholder')}
                value={campaignItems.name?.enUS}
                customWidth={'100%'}
                isDisabled={archiveSwitch || (campaignItems.id
                    && (!permissions?.hasCampaignUpdatePermissions && !permissions?.hasCampaignSuperAdminPermissions))}
                isRequired
                maxLength={100}
                textLength={`${campaignItems?.name?.enUS?.length || 0}/100`}
            />
        </StyledComponents.StyledCreateCampaignElementWrapper>
    );
};
